// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"598":"afa0f271","703":"69328183"}[chunkId] + ".chunk.js";
};